import gtm from '@/utils/gtm';
import { useGlobal } from '@/utils/useGlobal';
import EfDialogYoutube from '@elem/ui/ef-dialog-youtube';
import EFPicture from '@elem/ui/ef-picture';
import { FC, useState } from 'react';
import { oceanProConsultationUrl } from '../../config/pageConfig';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

const FirstKv: FC = () => {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');

    const { locale }: any = useRouter();

    const [open, setOpen] = useState(false);

    const CONTACT_LIST_ID: any = {
        us: '1130223527',
    };

    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;

    const contactListId = [`${CONTACT_LIST_ID[locale]}`];

    const SUB_SOURCE = 'WEB_NEW_PRODUCT_SUB';

    const SITE_ID: any = {
        us: '4423',
    };

    const ProductIds: any = {
        us: '12961',
    };
    const DateIds: any = {
        us: '9625',
    };

    const fields = [
        // 站点ID
        {
            id: SITE_ID[locale],
            type: 'single',
            value: 1,
            overwrite: true,
        },
        // Opt-In
        {
            id: '31',
            type: 'single',
            value: 1,
            overwrite: true,
        },
        // 产品字段 home_battery_leads
        {
            id: '12960',
            type: 'single',
            value: 1,
            overwrite: true,
        },
        // 产品字段 home_battery_leads_source
        {
            id: ProductIds[locale],
            type: 'multiple',
            value: 1,
            overwrite: false,
        },
        // 订阅日期 first_opt_in_date_us
        {
            id: DateIds[locale],
            type: 'text',
            value: dateString,
            overwrite: false,
        },
    ];

    const handleClickLink = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'select_banner',
            banner_name: t(`first_kv_title`),
            position: 'banner_1',
            button_name: t(`first_kv_btn_text`),
            __btn_id1: styles['first-kv'],
            __btn_id2: t('first_kv_btn_text'),
        });
        window.open(oceanProConsultationUrl, '_blank');
    };

    const handleClickCta = () => {
        window.open('https://homebattery.ecoflow.com/us/become-our-partner', '_blank');
    };

    return (
        <div className={`${styles['first-kv']} GtmModuleData-section`} data-section-id={styles['first-kv']} data-section-title={t('first_kv_title')}>
            <EFPicture
                src={'https://websiteoss.ecoflow.com/upload/image/1761277959542/kv.jpg'}
                srcPad={'https://websiteoss.ecoflow.com/upload/image/1752479738740/1023.jpg'}
                srcMobile={'https://websiteoss.ecoflow.com/upload/image/1752481422524/kv-h5.jpg'}
                alt={t('first_kv_title')}
                className="banner"
            />

            <div className="content">
                <div className="text-container top">
                    <h3>{t(`first_kv_sub_title`)}</h3>
                    <h1>{t(`first_kv_title`)}</h1>
                    <p className="desc">{t(`first_kv_sub_desc`)}</p>
                    <div className="btn-container">
                        <button className="eco-btn eco-btn-primary GtmModuleData-btn-text" onClick={handleClickLink}>
                            {t(`first_kv_btn_text`)}
                        </button>
                        <button className="eco-btn eco-btn-primary" onClick={handleClickCta}>
                            {t(`first_kv_btn_cta`)}
                        </button>
                        {/* <button className="eco-btn eco-btn-outline video-btn" onClick={() => setOpen(true)}>
                            {t(`first_kv_btn_video`)}
                            <svg xmlns="http://www.w3.org/2000/svg" className=" icon-play" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                <path
                                    d="M12.5 3C17.4706 3 21.5 7.02944 21.5 12C21.5 16.9706 17.4706 21 12.5 21C7.52944 21 3.5 16.9706 3.5 12C3.5 7.02944 7.52944 3 12.5 3ZM11.2939 8.57715C10.9636 8.3372 10.5003 8.57318 10.5 8.98145V15.0186C10.5003 15.4268 10.9636 15.6628 11.2939 15.4229L15.4443 12.4043C15.7185 12.2046 15.7185 11.7954 15.4443 11.5957L11.2939 8.57715Z"
                                    fill="black"
                                />
                            </svg>
                        </button> */}
                    </div>
                </div>
                {/* <div className="text-container bottom"> */}
                {/* <EcoEmail contactListId={contactListId} source={SUB_SOURCE} fields={fields} className={'cmp-email'} /> */}
                {/* <EmailSignUp locale="us" pageType="OceanProHomeSolarBattery" /> */}
                {/* </div> */}
                <EfDialogYoutube open={open} src={'https://www.youtube.com/embed/LaxudAGU9BM'} callback={() => setOpen(false)} />
            </div>
            <div className="award-wrap">
                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1761274960214/Award2.png" alt="Time BEST INVENTIONS 2025 " className="award1" />
                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1761274960433/Award1.png" alt="UX DESIGN AWARDS —— nominated 2023" className="award2" />
            </div>
        </div>
    );
};

export default FirstKv;
